import * as yup from 'yup';
import { phoneRegex } from '../../account/config/account-form.const';
import { IProfileCategory } from '../types/profile.types';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PaymentIcon from '@mui/icons-material/Payment';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ShareIcon from '@mui/icons-material/Share';
import RedeemIcon from '@mui/icons-material/Redeem';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import LogoutIcon from '@mui/icons-material/Logout';

export const PERSONAL_INFO_DEFAULT_VALUES = {
   firstName: '',
   lastName: '',
   email: '',
   phone: '',
};

export const PERSONAL_INFO_SCHEMA = yup.object({
   firstName: yup.string().required('First name is required'),
   lastName: yup.string().required('Last name is required'),
   email: yup.string().email('Email format is not valid').required('Email is required'),
   phone: yup.string().matches(phoneRegex, 'Invalid phone number').required('Phone number is required'),
});

export const PROFILE_CATEGORY_LIST: IProfileCategory[] = [
   { value: 0, name: 'Account Info', route: 'info', icon: <AccountCircleIcon /> },
   { value: 3, name: 'Your Subscriptions', route: 'subscriptions', icon: <AutorenewIcon /> },
   { value: 4, name: 'Your Orders', route: 'orders', icon: <ShoppingCartIcon /> },
   { value: 1, name: 'Your Addresses', route: 'addresses', icon: <LocationOnIcon /> },
   { value: 5, name: 'Payment Options', route: 'payments', icon: <PaymentIcon /> },
   { value: 7, name: 'Referral Code', route: 'referral', icon: <ShareIcon /> },
   { value: 8, name: 'Rewards', route: 'rewards', icon: <RedeemIcon /> },
   { value: 2, name: 'Reset Password', route: 'reset', icon: <VpnKeyIcon /> },
   { value: 6, name: 'Sign Out', route: 'signout', icon: <LogoutIcon /> },
];
